module.exports = __webpack_public_path__ + "img/earth_atmos_4096.5443d526.jpg";